/*
  Side menu groups by task. Merged FIRST into TRANSLATION_MAPS in ./index.js,
  so existing translations still win. Keys are the English source.
*/

const ru = {
  "Launch": "Запуск",
  "Partners and conversions": "Партнёры и конверсии",
  "Statistics": "Статистика",
  "Protection": "Защита",
};

const es = {
  "Launch": "Lanzamiento",
  "Partners and conversions": "Socios y conversiones",
  "Statistics": "Estadísticas",
  "Protection": "Protección",
};

const pt = {
  "Launch": "Lançamento",
  "Partners and conversions": "Parceiros e conversões",
  "Statistics": "Estatísticas",
  "Protection": "Proteção",
};

const de = {
  "Launch": "Start",
  "Partners and conversions": "Partner und Conversions",
  "Statistics": "Statistik",
  "Protection": "Schutz",
};

const fr = {
  "Launch": "Lancement",
  "Partners and conversions": "Partenaires et conversions",
  "Statistics": "Statistiques",
  "Protection": "Protection",
};

const it = {
  "Launch": "Avvio",
  "Partners and conversions": "Partner e conversioni",
  "Statistics": "Statistiche",
  "Protection": "Protezione",
};

const pl = {
  "Launch": "Uruchomienie",
  "Partners and conversions": "Partnerzy i konwersje",
  "Statistics": "Statystyki",
  "Protection": "Ochrona",
};

const tr = {
  "Launch": "Başlatma",
  "Partners and conversions": "İş ortakları ve dönüşümler",
  "Statistics": "İstatistikler",
  "Protection": "Koruma",
};

const uk = {
  "Launch": "Запуск",
  "Partners and conversions": "Партнери та конверсії",
  "Statistics": "Статистика",
  "Protection": "Захист",
};

const MENU_GROUPS = { ru, es, pt, de, fr, it, pl, tr, uk };
export default MENU_GROUPS;
